<template>
  <!-- 奖池弹窗（奖池图片） -->
  <div v-if="isShown">
    <div class="Dialog jc-prize">
       <div class="inner-box">
        <div class="inner">
			<i class="close" @click="close"></i>
			<div class="jc-prize-box">
                <div class="ribbons"></div>
				<div class="caption">
					<img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
					{{lotteryInfo.name}} 奖品一览
					<img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
				</div>		
                <p class="prize-tip2" v-if="lotteryInfo.resultName">组队成功后，个人消费超过{{lotteryInfo.num}}{{currencyName}}即可领取以下奖励</p>
                <p class="prize-tip2" v-else>团队共消耗{{lotteryInfo.num}}{{currencyName}}且个人消耗>1{{currencyName}}即可随机获得以下奖励</p>
                <div class="prize-props">
					<img v-for="(img,i) in lotteryInfo.imgList" key="'lotteryInfoImg' + i" v-if="img" class="prize-props-img" :src="img" alt="" />
				</div>
			</div>

		</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import myMinin from "./mixin"

export default {
  name: "AwardDialog",
  props: ["isShown", "lotteryInfo", "gameInfo"],
  mixins: [myMinin],
  computed: {
    currencyName() {
      return this.gameInfo?.shop?.currency || "点券"
    }
  },
  methods: {
    ...mapActions(["reportUserAction"])
  }
}
</script>

<style scoped>
</style>
